import styles from 'legacy/common/components/form/Form.module.scss';

import * as Yup from 'yup';
import { useState } from 'react';
import classnames from 'classnames';
import { Field, Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';

import { handleLogin } from 'legacy/auth/helpers';
import { useEmailRegisterCommand } from 'legacy/auth/hooks';

import Button, { ButtonType } from 'legacy/common/components/button/Button';

const SignUpSchema = Yup.object().shape({
  email: Yup.string().email('Must be a valid email').required('Required'),
  password: Yup.string().required('Required'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Required')
});

const SignUpForm = () => {
  const { t } = useTranslation('auth');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((isPasswordVisible) => !isPasswordVisible);
  };

  const [isPasswordConfirmationVisible, setIsPasswordConfirmationVisible] =
    useState(false);
  const togglepasswordConfirmationVisibility = () => {
    setIsPasswordConfirmationVisible(
      (isPasswordConfirmationVisible) => !isPasswordConfirmationVisible
    );
  };

  const { mutate, isLoading, error } = useEmailRegisterCommand();

  return (
    <>
      <p className={styles.submitError}>{error?.message}</p>

      <Formik
        initialValues={{
          email: '',
          password: '',
          passwordConfirmation: ''
        }}
        onSubmit={(values) => {
          mutate(values, {
            onSuccess: (data) => {
              handleLogin(data);
            }
          });
        }}
        validationSchema={SignUpSchema}
      >
        {({ errors, touched, dirty }) => (
          <Form>
            <div className={styles.group}>
              {/* Email */}
              <p className={classnames([styles.label, styles.small])}>Email</p>
              <Field
                id="email"
                name="email"
                type="text"
                placeholder={t('placeholders.enterEmail')}
                className={classnames(styles.input, {
                  [styles.errorField]: errors.email && touched.email
                })}
              />
              {errors.email && touched.email && (
                <div className={classnames(styles.error, styles.right)}>
                  {errors.email}
                </div>
              )}

              {/* Password */}
              <p className={classnames(styles.label, styles.small)}>Password</p>
              <div className={styles.relative}>
                <Field
                  id="password"
                  name="password"
                  type={isPasswordVisible ? 'text' : 'password'}
                  placeholder={t('placeholders.enterPassword')}
                  className={classnames(styles.input, {
                    [styles.errorField]: errors.password && touched.password
                  })}
                />
                {errors.password && touched.password && (
                  <div className={classnames(styles.error, styles.right)}>
                    {errors.password}
                  </div>
                )}
                <div
                  className={styles.inputIcon}
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? (
                    <img src="/img/icons/eye.svg" />
                  ) : (
                    <img src="/img/icons/eye-slash.svg" />
                  )}
                </div>
              </div>

              {/* Confirm Password */}
              <p className={classnames(styles.label, styles.small)}>
                Confirm Password
              </p>
              <div className={styles.relative}>
                <Field
                  id="passwordConfirmation"
                  name="passwordConfirmation"
                  type={isPasswordConfirmationVisible ? 'text' : 'password'}
                  placeholder={t('placeholders.enterPassword')}
                  className={classnames(styles.input, {
                    [styles.errorField]:
                      errors.passwordConfirmation &&
                      touched.passwordConfirmation
                  })}
                />
                {errors.passwordConfirmation &&
                  touched.passwordConfirmation && (
                    <div className={classnames(styles.error, styles.right)}>
                      {errors.passwordConfirmation}
                    </div>
                  )}
                <div
                  className={styles.inputIcon}
                  onClick={togglepasswordConfirmationVisibility}
                >
                  {isPasswordConfirmationVisible ? (
                    <img src="/img/icons/eye.svg" />
                  ) : (
                    <img src="/img/icons/eye-slash.svg" />
                  )}
                </div>
              </div>
            </div>

            <div className={styles.group}>
              <Button
                isSubmit
                disabled={!dirty}
                loading={isLoading}
                type={ButtonType.Primary}
              >
                Sign Up
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SignUpForm;
